import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueScrollTo from 'vue-scrollto';
import VueSanitize from 'vue-sanitize';
import SalesChannelComponents from '@lotify/sales-channel-components';
import SalesChannelComponentsDev from '@lotify/sales-channel-components/src/main';
import KnvbComponents from '@/plugins/knvb-components';
import KWFComponents from '@/plugins/kwf-components';
import ComponentRenderer from '@/components/ComponentRenderer';
import * as Sentry from '@sentry/vue';
import { createEventLogger } from '@/plugins/event-logger';
import { __DEV__ } from '@/constants';
import '@/filters/cdn_filter';

require('@/assets/scss/components/components.scss');
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { createApiPlugin } from '@/plugins/api-plugin';
import { createCdnFilter } from '@/filters/cdn_filter';

Vue.config.productionTip = false;

Vue.component('ComponentRenderer', ComponentRenderer);

if (process.env.VUE_APP_EDITOR) {
    require('./plugins/editor');
}

if (process.env.VUE_APP_SENTRY_DSN !== '') {
    Sentry.init({ Vue, dsn: process.env.VUE_APP_SENTRY_DSN });
}

Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
    loaderOptions: { autoHideBadge: true },
});

const scc = __DEV__ ? SalesChannelComponentsDev : SalesChannelComponents;
Vue.use(scc);
Vue.use(KnvbComponents);
Vue.use(KWFComponents);

const toastOptions = {};
Vue.use(Toast, toastOptions);

let VueSanitizeOptions = VueSanitize.defaults;
VueSanitizeOptions.allowedTags = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'p',
    'a',
    'ul',
    'ol',
    'nl',
    'li',
    'b',
    'i',
    'strong',
    'em',
    'strike',
    'code',
    'hr',
    'br',
    'div',
    'table',
    'thead',
    'caption',
    'tbody',
    'tr',
    'th',
    'td',
    'pre',
    'img',
];
VueSanitizeOptions.allowedAttributes.img = ['src', 'width', 'height', 'style'];
Vue.use(VueSanitize, VueSanitizeOptions);

Vue.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: -100,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});

Vue.use(VueMeta);
let cdn = createCdnFilter(store);
Vue.filter('cdn', cdn);
Vue.prototype.$cdn = cdn;

const eventLogger = createEventLogger();
Vue.use(eventLogger);

const apiPlugin = createApiPlugin(store);
Vue.use(apiPlugin);

new Vue({
    name: 'SalesChannel',
    router,
    store,
    render: h => h(App),
}).$mount('#app');
